export const hireReport = {
  id: 'hires',
  name: 'Hires',
  description: '',
  visibility: 'private',
  subject: 'hires',
  layout: {
    data: [
      {
        h: 7,
        w: 6,
        x: 0,
        y: 0,
        key: '4788',
        maxH: 13,
        maxW: 6,
        minH: 7,
        minW: 3,
      },
      {
        h: 7,
        w: 6,
        x: 6,
        y: 0,
        key: '4789',
        maxH: 13,
        maxW: 6,
        minH: 7,
        minW: 3,
      },
      {
        h: 23,
        w: 12,
        x: 0,
        y: 7,
        key: '4790',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 23,
        w: 6,
        x: 6,
        y: 30,
        key: '4792',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 53,
        key: '4793',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
      {
        h: 23,
        w: 6,
        x: 0,
        y: 30,
        key: '4794',
        maxH: 32,
        maxW: 12,
        minH: 21,
        minW: 3,
      },
    ],
  },
  tiles: [
    {
      id: 4788,
      subject_type: 'hires',
      metadata: {
        id: 'hires_no_of_hires',
        tileKey: 'hires_no_of_hires',
        apiParam: 'card',
        headerKey: 'hires',
        componentType: 'card',
      },
      query: null,
    },
    {
      id: 4789,
      subject_type: 'hires',
      metadata: {
        id: 'hires_time_to_hire',
        unit: 'time',
        tileKey: 'hires_time_to_hire',
        apiParam: 'card',
        metricKeys: {
          numerator: 'time_to_hire',
          denominator: 'hires',
        },
        componentType: 'card',
        calculationType: 'avgChange',
      },
      query: null,
    },
    {
      id: 4790,
      subject_type: 'hires',
      metadata: {
        id: 'hires_trend_chart',
        tileKey: 'hires_trend_chart',
        apiParam: 'chart_table',
        headerKeys: [],
        componentType: 'chart',
      },
      query: null,
    },
    {
      id: 4792,
      subject_type: 'hires',
      metadata: {
        id: 'hires_source_chart',
        tileKey: 'hires_source_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'appl_contact_source',
        },
      },
      query: null,
    },
    {
      id: 4793,
      subject_type: 'hires',
      metadata: {
        id: 'hires_table',
        tileKey: 'hires_table',
        apiParam: 'chart_table',
        headerKeys: [
          'hires_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
      },
      query: null,
    },
    {
      id: 4794,
      subject_type: 'hires',
      metadata: {
        id: 'hires_department_chart',
        tileKey: 'hires_department_chart',
        apiParam: 'visual',
        headerKeys: [],
        componentType: 'chart',
        defaultFilters: {
          group_by_1: 'department',
        },
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
